import React from "react";
import client from "../apis";

const BookingContext = React.createContext();

function BookingProvider(props) {
    const [token, setToken] = React.useState();
    const [business, setBusiness] = React.useState();
    const [zone, setZone] = React.useState();
    const [date, setDate] = React.useState();
    const [time, setTime] = React.useState("Seleziona un orario");
    const [seats, setSeats] = React.useState();
    const [guest, setGuest] = React.useState();

    async function loadBusiness(token) {
        let response = await client.filter("businesses", token);
        setBusiness(response.data.data[0]);
    }

    async function loadBusinessOld(token) {
        let response = await client.getBusinessOld(token);
        setBusiness({ attributes: { ...response.data } });
    }

    React.useEffect(() => {
        token && loadBusinessOld(token);
    }, [token]);

    const value = {
        token,
        business,
        zone,
        date,
        time,
        seats,
        guest,
        setToken,
        loadBusiness,
        setZone,
        setDate,
        setTime,
        setSeats,
        setGuest,
    }

    return <BookingContext.Provider value={value} {...props} />;
}

function useBooking() {
    const context = React.useContext(BookingContext);
    if (!context) {
        throw new Error("useBooking must be used within a BookingProvider");
    }
    return context;
}

export {
    BookingProvider,
    useBooking,
}
